

  let tabs = document.querySelectorAll(".tabs h3");
    let tabContents = document.querySelectorAll(".tab-content > div");
    
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabContents.forEach((content) => {
          content.classList.remove("active");
        });
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tabContents[index].classList.add("active");
        tabs[index].classList.add("active");
      });
    });
 
     $(".filter_desktop_tab_collections li").on("click",function(){
       $(".filter_desktop_tab_collections li").removeClass("active");
       $(this).addClass("active");
       $(".filter_tab_collections .grid__item").removeClass("temp-hide");
       let value = $(this).data("filter");
       console.log(value);
       if(value == "all"){
        $(".filter_tab_collections .grid__item").removeClass("temp-hide");
       }else{
         $(".filter_tab_collections .grid__item:not(.tag-"+value+")").addClass("temp-hide");
       }
     }); 


   $(".filter_mobile_tab_collections").on("change",function(){ 
       $(".filter_tab_collections .grid__item").removeClass("temp-hide");
       let value = $(".filter_mobile_tab_collections option:checked").val();
       console.log(value);
       if(value == "all"){
        $(".filter_tab_collections .grid__item").removeClass("temp-hide");
       }else{
         $(".filter_tab_collections .grid__item:not(.tag-"+value+")").addClass("temp-hide");
       }
     }); 